import {createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw} from 'vue-router';
import LoginView from "../login/views/LoginView.vue";
import LoginAsView from "../login/views/LoginAsView.vue";
import {endSession} from "../login/logout";
import DatabaseNotificationHistory from "../notification/views/DatabaseNotificationHistory.vue";
import Tutorial from "../home/views/Tutorial.vue";
import PatchNotesScreen from "../home/views/PatchNotesScreen.vue";
import Support from "../home/views/Support.vue";
import HomeScreen from "../home/views/HomeScreen.vue";
import Customer from "../customer/views/Customer.vue";
import CustomerHome from "../customer/components/customer-home/CustomerHome.vue";
import BeneficiaryHome from "../customer/components/customer-beneficiary/BeneficiaryHome.vue";
import PetHome from "../customer/components/customer-beneficiary/PetHome.vue";
import PetCreate from "../customer/components/customer-beneficiary/PetCreate.vue";
import CustomerPrescriptions from "../customer/components/customer-prescriptions/CustomerPrescriptions.vue";
import LoyaltyCardMembershipScreen from "../loyalty-card-membership/views/LoyaltyCardMembershipScreen.vue";
import CustomerSurveys from "../customer/components/customer-surveys/CustomerSurveys.vue";
import CustomerCertificationOnboarding from "../customer-certification/views/CustomerCertificationOnboarding.vue";
import CustomerSupportProgram from "../customer/views/CustomerSupportProgram.vue";
import CustomerClickCollect from "../customer/components/customer-click-collect/CustomerClickCollect.vue";
import OnboardingView from "@/onboarding/views/OnboardingView.vue";
import electronHelper from "@/core/services/electronHelper";
import Register from "@/register/views/Register.vue";
import ProgramDetails from "@/program/views/ProgramDetails.vue";
import ProgramDetailContent from "@/program/views/ProgramDetailContent.vue";
import ProgramConsumers from "@/program/components/program-consumers/ProgramConsumers.vue";
import SupportProgramPathwayDetail from "@/program/views/SupportProgramPathwayDetail.vue";
import SupportProgramProductRecommendations from "@/program/views/SupportProgramProductRecommendations.vue";
import LoyaltyCardAnimations from "@/loyalty-card/views/LoyaltyCardAnimations.vue";
import LoyaltyCardAnimationTransactions from "@/loyalty-card/views/LoyaltyCardAnimationTransactions.vue";
import ProgramDetailAttachments from "@/program/views/ProgramDetailAttachments.vue";
import NotificationSettings from "@/settings/screens/NotificationSettings.vue";
import Notification from "@/notification/views/Notification.vue";
import NotificationDragOverlay from "@/notification/views/NotificationDragOverlay.vue";
import CustomerInterviews from "@/interview/views/CustomerInterviews.vue";
import CustomerFeatureProgram from "@/customer/views/CustomerFeatureProgram.vue";
import ProgramBundleDetails from "@/program/views/ProgramBundleDetails.vue";
import ProgramBundleProgramCategoryDetails from "@/program/views/ProgramBundleProgramCategoryDetails.vue";
import ProgramBundleProgramCategoryResource from "@/program/views/ProgramBundleProgramCategoryResource.vue";
import ProgramBundleProgramCategoryPrograms from "@/program/views/ProgramBundleProgramCategoryPrograms.vue";
import ProgramBundleProgramCategoryConsumers from "@/program/views/ProgramBundleProgramCategoryConsumers.vue";
import disruptionLogisticsRouter from "@/disruption-logistics/disruptionLogisticsRouter";
import sponsorshipRouter from "@/sponsorship/sponsorshipRouter";
import LinkCPS from "@/onboarding/views/LinkCPS.vue";
import HealthcenterView from "@/healthcenter/views/HealthcenterView.vue";
import subscriptionPlanRouter from "@/subscription-plan/subscriptionPlanRouter";
import stripeRouter from "@/stripe/stripeRouter";
import stripeConnectRouter from "@/stripe-connect/stripeConnectRouter";
import interviewRouter from "@/interview/interviewRouter";
import extensionStoreRouter from "@/extension/extensionRouter";
import HospitalView from "@/hospital/views/HospitalView.vue";
import ApplicationLoadingView from "@/core/views/ApplicationLoadingView.vue";
import PrescriptionRenewalPlanEditScreen from "@/prescription/views/PrescriptionRenewalPlanEditScreen.vue";
import PrescriptionRenewalPlanShowScreen from "@/prescription/views/PrescriptionRenewalPlanShowScreen.vue";
import ChangeForgotPassword from "@/login/views/ChangeForgotPassword.vue";
import NotFoundView from "@/core/views/NotFoundView.vue";
import BillingView from "@/billing/views/BillingView.vue";
import RegisterGuest from "@/register/views/RegisterGuest.vue";
import laboratoryRouter from "@/laboratory/laboratoryRouter";
import knowledgeBoxRouter from "@/knowledge-box/knowledgeBoxRouter";
import PrescriptionAnalysisScreen from "@/prescription/views/PrescriptionAnalysisScreen.vue";
import ContractView from "@/contract/views/ContractView.vue";
import patientAdministrationRouter from "@/patient-administration/patientAdministrationRouter";
import loyaltyCardRouter from "@/loyalty-card/router";
import CustomerDrugInteractionScreen from "@/customer/views/CustomerDrugInteractionScreen.vue";
import LoyaltyCardAnimationCreate from "@/loyalty-card/views/LoyaltyCardAnimationCreate.vue";
import ExperienceView from "@/experience/views/ExperienceView.vue";
import groupingRouter from "@/grouping/groupingRouter";
import CustomerSurveyBuilt from "@/customer/views/CustomerSurveyBuilt.vue";
import UncertifiedCustomerSurveyBuilt from "@/customer/views/UncertifiedCustomerSurveyBuilt.vue";
import PrivacyPolicyContractView from "@/contract/views/PrivacyPolicyContractView.vue";
import MedicineCabinetCustomize from "@/program/components/medicine-cabinet-customize/MedicineCabinetCustomize.vue";
import medicineCabinetRouter from "@/medicine-cabinet/router";
import CustomerHospitals from "@/customer/views/CustomerHospitals.vue";
import ASAFOIndexView from "@/asafo/views/ASAFOIndexView.vue";
import ASAFOCustomerView from "@/asafo/views/ASAFOCustomerView.vue";
import ReconciliationCandidateIndexView from "@/consumer-reconciliation/views/ReconciliationCandidateIndexView.vue";
import ReconciliationIndexView from "@/consumer-reconciliation/views/ReconciliationIndexView.vue";
import FlowchartIndexView from "@/flowcharts/views/FlowchartIndexView.vue";
import FlowchartShowView from "@/flowcharts/views/FlowchartShowView.vue";
import TeamView from "@/team/views/TeamView.vue";
import PlanningView from "@/planning/views/PlanningView.vue";
import TeamTasksView from "@/team-task/views/TeamTasksView.vue";
import cardlessDetectionRouter from "@/cardless/cardlessDetectionRouter";
import ConsumerProductTrackingView from "@/drug-interaction/views/ConsumerProductTrackingView.vue";
import contestRouter from "@/contest/contestRouter";
import ProgramNotificationSequences from "@/program/views/ProgramNotificationSequences.vue";
import ProgramNotificationSequence from "@/program/views/ProgramNotificationSequence.vue";
import TenantTutorial from "@/home/views/TenantTutorial.vue";
import TeamTutorial from "@/home/views/TeamTutorial.vue";
import CustomerConversation from "@/customer/views/CustomerConversation.vue";
import CustomerAppointments from "@/customer/views/CustomerAppointments.vue";
import {MedicationCheckupRouter} from "@/medication-checkup/MedicationCheckupRouter";
import FeatureHighlightsReplay from "@/home/views/FeatureHighlightsReplay.vue";
import rcsRouter from "@/rcs/router";
import agendaRouter from "@/agenda/router";
import ProgramConversationMessages from "@/program/views/ProgramConversationMessages.vue";

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'onboarding',
        component: OnboardingView,

        meta: {
            layout: 'TheWebsiteLayout'
        }
    },
    {
        path: '/home',
        name: 'home',
        component: HomeScreen,
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView,
        meta: {
            layout: 'TheAuthenticationLayout'
        }
    },
    /*
     * Logging out is a navigation: the leave guards of the current page run
     * first, the session still alive, so a page guarding unsaved work (the
     * recurring schedule) can save it or keep the pharmacist there. The
     * session ends only once the page is left, and before the login page
     * mounts, which would otherwise relaunch the app on the remaining token.
     */
    {
        path: '/logout',
        name: 'logout',
        // Never rendered: the guard below always redirects to the login page.
        component: {render: () => null},
        beforeEnter: async () => {
            await endSession();

            return {name: 'login'};
        }
    },

    {
        path: '/login/as',
        name: 'login.as',
        component: LoginAsView
    },

    {
        path: '/register',
        name: 'register',
        component: Register,

        meta: {
            layout: 'TheAuthenticationLayout'
        }
    },
    {
        path: '/register/:hash',
        name: 'register.guest',
        component: RegisterGuest,

        meta: {
            layout: 'TheAuthenticationLayout'
        }
    },
    {
        path: '/linkcps',
        name: 'linkcps',
        component: LinkCPS,

        meta: {
            layout: 'TheAuthenticationLayout'
        }
    },

    {
        path: '/app-loading',
        name: 'app.loading',
        component: ApplicationLoadingView,
        meta: {
            layout: 'TheBlankLayout'
        }
    },

    {
        path: '/change-forgot-password/:code',
        name: 'change-forgot-password',
        component: ChangeForgotPassword,

        meta: {
            layout: 'TheAuthenticationLayout'
        }
    },

    {
        path: '/patch-notes',
        name: 'patch-notes',
        component: PatchNotesScreen
    },

    {
        path: '/feature-highlights',
        name: 'feature-highlights',
        component: FeatureHighlightsReplay
    },

    {
        path: '/notification',
        name: 'notification',
        component: Notification,

        meta: {
            title: 'Notifications',
            layout: 'TheNotificationLayout'
        }
    },
    {
        path: '/notification-drag-overlay',
        name: 'notification.drag-overlay',
        component: NotificationDragOverlay,

        meta: {
            title: 'Déplacement de la notification',
            layout: 'TheBlankLayout'
        }
    },
    {
        path: '/notification/preference',
        name: 'notification.preference',
        component: NotificationSettings,

        meta: {
            title: 'Paramètres de notification'
        }
    },
    {
        path: '/notification/history',
        name: 'notification.history',
        component: DatabaseNotificationHistory,

        meta: {
            title: 'Notifications'
        }
    },
    {
        path: '/tutorial',
        name: 'tutorial',
        component: Tutorial,
        redirect() {
            return {name: 'tutorial.tenant'};
        },
        meta: {
            title: 'Apodis Academy'
        },
        children: [
            {
                path: 'tenant',
                name: 'tutorial.tenant',
                component: TenantTutorial,
            },
            {
                path: 'team',
                name: 'tutorial.team',
                component: TeamTutorial,
            }
        ],
    },
    {
        path: '/billing',
        name: 'billing',
        component: BillingView,

        meta: {
            title: 'Facturation'
        }
    },
    {
        path: '/experience',
        name: 'experience',
        component: ExperienceView,

        meta: {
            title: ''
        }
    },

    {
        path: '/healthcenter',
        name: 'healthcenter',
        component: HealthcenterView,

        meta: {
            title: 'Ma pharmacie'
        }
    },
    {
        path: '/team',
        name: 'team',
        component: TeamView,

        meta: {
            title: 'Mon équipe'
        }
    },
    {
        path: '/planning',
        name: 'planning',
        component: PlanningView,

        meta: {
            title: 'Planning équipe'
        }
    },
    {
        path: '/team-tasks',
        name: 'team-tasks',
        component: TeamTasksView,

        meta: {
            title: 'Tâches de l\'équipe'
        }
    },
    {
        path: '/hospital',
        name: 'hospital',
        component: HospitalView,

        meta: {
            title: 'Lien ville-hôpital'
        }
    },
    {
        path: '/support',
        name: 'support',
        component: Support,

        meta: {
            title: 'Support'
        }
    },
    {
        path: '/cgu',
        name: 'cgu',
        component: ContractView,

        meta: {
            title: 'CGU'
        }
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: PrivacyPolicyContractView,

        meta: {
            title: 'Politique de confidentialité des données'
        }
    },
    {
        path: '/uncertified/survey-instances/:instanceId',
        name: 'uncertified.survey-built',
        component: UncertifiedCustomerSurveyBuilt,
        props: true
    },
    {
        path: '/customer/:customerId',
        name: 'customer',
        component: Customer,

        children: [
            {
                path: 'home',
                name: 'customer.home',
                component: CustomerHome
            },
            {
                path: 'appointments',
                name: 'customer.appointments',
                component: CustomerAppointments
            },
            {
                path: 'drug-interactions',
                name: 'customer.drug-interactions',
                component: CustomerDrugInteractionScreen
            },
            {
                path: 'beneficiary/:id',
                name: 'customer.beneficiary',
                component: BeneficiaryHome
            },
            {
                path: 'pet/:id',
                name: 'customer.pet',
                component: PetHome,
            },
            {
                path: 'pets',
                name: 'customer.pet.create',
                component: PetCreate,
            },
            {
                name: 'customer.certification',
                path: 'certification',
                component: CustomerCertificationOnboarding
            },
            {
                path: 'prescriptions',
                name: 'customer.prescriptions',
                component: CustomerPrescriptions
            },
            {
                path: 'prescriptions/:prescriptionId',
                name: 'customer.prescriptions.show',
                children: [
                    {
                        path: 'control',
                        name: 'customer.prescriptions.control',
                        component: PrescriptionAnalysisScreen
                    },
                    {
                        path: 'renewal',
                        name: 'customer.prescriptions.renewal.show',
                        component: PrescriptionRenewalPlanShowScreen
                    },
                    {
                        path: 'renewals/:renewalId',
                        name: 'customer.prescriptions.renewal.edit',
                        component: PrescriptionRenewalPlanEditScreen
                    },
                ]
            },
            {
                path: 'click-collect',
                name: 'customer.click-collect',
                component: CustomerClickCollect
            },
            {
                path: 'hospitals',
                name: 'customer.hospitals',
                component: CustomerHospitals
            },
            {
                path: 'loyalty/membership/:membershipId',
                name: 'customer.loyalty.membership',
                component: LoyaltyCardMembershipScreen
            },
            {
                path: 'survey-instances/:instanceId',
                name: 'customer.survey',
                component: CustomerSurveyBuilt,
            },
            {
                path: 'survey-instances',
                name: 'customer.survey.list',
                component: CustomerSurveys
            },
            {
                path: 'conversation',
                name: 'customer.conversation',
                component: CustomerConversation
            },
            {
                path: 'consumer/:consumerKey/programs/:programId/support-program',
                name: 'consumer.support-program',
                component: CustomerSupportProgram
            },
            {
                path: 'consumer/:consumerKey/products-tracking',
                name: 'customer.products-tracking',
                component: ConsumerProductTrackingView,
                props: true
            },
            {
                path: 'feature-programs/:programId?/:consumerKey?',
                name: 'customer.feature-program',
                component: CustomerFeatureProgram
            },
            {
                path: 'interviews',
                name: 'customer.interviews',
                component: CustomerInterviews
            },
        ],
    },
    {
        path: '/program-bundle/:programBundleId',
        name: 'program-bundle.detail',
        component: ProgramBundleDetails
    },
    {
        path: '/program-bundle/:programBundleId/category/:programCategoryId',
        name: 'program-bundle.detail.category',
        component: ProgramBundleProgramCategoryDetails,
        children: [
            {
                path: 'attachments',
                name: 'program-bundle.detail.category.attachments',
                component: ProgramBundleProgramCategoryResource
            },
            {
                path: 'programs',
                name: 'program-bundle.detail.category.programs',
                component: ProgramBundleProgramCategoryPrograms
            },
            {
                path: 'consumers',
                name: 'program-bundle.detail.category.consumers',
                component: ProgramBundleProgramCategoryConsumers
            }
        ]
    },
    {
        path: '/program/:programId',
        name: 'program.detail',
        component: ProgramDetails,
        children: [
            {
                path: '/program/:programId/content',
                name: 'program.detail.content',
                component: ProgramDetailContent,
                props: true
            },
            {
                path: '/program/:programId/patients',
                name: 'program.detail.consumers',
                component: ProgramConsumers,
                props: true
            },
            {
                path: '/program/:programId/conversation-messages',
                name: 'program.details.conversation-messages',
                component: ProgramConversationMessages,
                props: true
            },
            {
                path: '/program/:programId/attachments',
                name: 'program.detail.attachments',
                component: ProgramDetailAttachments,
                props: true
            },
            {
                path: '/program/:programId/pathway',
                name: 'program.detail.pathway',
                component: SupportProgramPathwayDetail,
                props: true
            },
            {
                path: '/program/:programId/support-programs/:supportProgramId/product-recommendations',
                name: 'program.detail.product-recommendations',
                component: SupportProgramProductRecommendations,
                props: true
            },
            {
                path: '/program/:programId/customize',
                name: 'program.detail.customize',
                component: MedicineCabinetCustomize,
                props: true
            },
            {
                path: '/program/:programId/animations',
                name: 'program.detail.animations',
                component: LoyaltyCardAnimations,
                props: true
            },
            {
                path: '/program/:programId/animations/create',
                name: 'program.detail.animations.create',
                component: LoyaltyCardAnimationCreate,
                props: true
            },
            {
                path: '/program/:programId/animations/:animationId/transactions',
                name: 'program.detail.animations.transactions',
                component: LoyaltyCardAnimationTransactions,
                props: true
            },
            {
                path: '/program/:programId/notification-sequences',
                name: 'program.detail.notification-sequences',
                component: ProgramNotificationSequences,
                props: true
            },
            {
                path: '/program/:programId/notification-sequences/:sequenceId',
                name: 'program.detail.notification-sequences.show',
                component: ProgramNotificationSequence,
                props: true
            },
            ...loyaltyCardRouter,
            ...medicineCabinetRouter
        ]
    },
    {
        path: '/asafo',
        name: 'asafo',
        component: ASAFOIndexView,
    },
    {
        path: '/asafo/:id',
        name: 'asafo.customer',
        component: ASAFOCustomerView,
    },
    {
        path: '/flowcharts',
        name: 'flowcharts.index',
        component: FlowchartIndexView,
    },
    {
        path: '/flowcharts/:id',
        name: 'flowcharts.show',
        component: FlowchartShowView,
    },
    {
        path: '/consumer-reconciliations',
        name: 'consumer-reconciliations',
        children: [
            {
                path: '/consumer-reconciliations/candidates',
                name: 'consumer-reconciliations.candidates',
                component: ReconciliationCandidateIndexView,
            },
            {
                path: '/consumer-reconciliations/index',
                name: 'consumer-reconciliations.index',
                component: ReconciliationIndexView,
            },
        ]
    },
    ...disruptionLogisticsRouter,
    ...sponsorshipRouter,
    ...subscriptionPlanRouter,
    ...stripeRouter,
    ...stripeConnectRouter,
    ...extensionStoreRouter,
    ...interviewRouter,
    ...laboratoryRouter,
    ...knowledgeBoxRouter,
    ...patientAdministrationRouter,
    ...groupingRouter,
    ...cardlessDetectionRouter,
    ...contestRouter,
    ...MedicationCheckupRouter,
    ...rcsRouter,
    ...agendaRouter
];

const router = createRouter({
    history: electronHelper.isElectron() ? createWebHashHistory() : createWebHistory(),
    routes: [
        ...routes,
        {
            path: '/:pathMatch(.*)',
            component: NotFoundView,
            meta: {
                layout: electronHelper.isElectron() ? 'TheApplicationLayout' : 'TheBlankLayout'
            }
        }
    ]
});

export default router;
